import {createFileRoute} from '@tanstack/react-router';
import {ProfilePage} from '../../../../features/settings/pages/ProfilePage/ProfilePage';

export const Route = createFileRoute('/_protected/home/service/profile')({
  component: ProfilePage,
  staticData: {crumbKey: 'navigation.profile'},
});
